import { BaseApi } from '@api/core/base.api';
import { IRequestVerificationResponse } from '@api/verification/verification-api.interfaces';
import endpoints from '@config/endpoints';

export class VerificationApi extends BaseApi {
  public request() {
    return this.client.get<IRequestVerificationResponse>(endpoints.VERIFICATION.REQUEST);
  }
}
